import { useEffect, useState } from 'react';

export function useDetectUserTouch() {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    window.addEventListener(
      'touchstart',
      function onFirstTouch() {
        setIsTouch(true);
        // we only need to know once that a human touched the screen, so we can stop listening now
        window.removeEventListener('touchstart', onFirstTouch, false);
      },
      false,
    );
  }, []);

  return isTouch;
}
